(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brox-card-availability"] && !Shopify.designMode) return;
  try {
    (() => {
  function registerCardStock() {
    if (customElements.get('brox-card-stock')) return;
    const configElement = document.querySelector('[data-brox-card-stock-config]');
    if (!configElement) return;
    const config = JSON.parse(configElement.textContent);
    const rules = window.BroxStockRules;
    const cache = new Map();
    const pending = new Map();
    const queue = [];
    const cards = new Set();
    let activeRequests = 0;
    let flushTimer;

    const cardStatus = type => ['marcor', 'jrp', 'turn14'].includes(type) ? 'warehouse' : type;
    const cacheLifetime = 60000;
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        entry.target.nearViewport = entry.isIntersecting;
        if (entry.isIntersecting) entry.target.load();
      });
    }, { rootMargin: '300px' }) : null;

    function requestStock(handle) {
      const previous = cache.get(handle);
      if (previous && previous.expires > Date.now()) return Promise.resolve(previous.data);
      if (pending.has(handle)) return pending.get(handle).promise;
      let resolve;
      const promise = new Promise(done => { resolve = done; });
      pending.set(handle, { promise, resolve });
      queue.push(handle);
      clearTimeout(flushTimer);
      flushTimer = setTimeout(flush, 20);
      return promise;
    }

    function settle(handle, data) {
      cache.delete(handle);
      cache.set(handle, { data, expires: Date.now() + (data ? cacheLifetime : 5000) });
      if (cache.size > 200) cache.delete(cache.keys().next().value);
      pending.get(handle)?.resolve(data);
      pending.delete(handle);
    }

    async function fetchBatch(handles) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const url = new URL(config.searchUrl, window.location.origin);
        url.searchParams.set('view', 'brox-card-stock');
        url.searchParams.set('q', handles.join(','));
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'none');
        // The preview theme and locale must also be used by this read-only request.
        const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Stock request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const payload = JSON.parse(html.querySelector('[data-brox-card-stock-response]')?.textContent || 'null');
        if (payload?.version !== 1 || !Array.isArray(payload.products)) throw new Error('Invalid stock response');
        const byHandle = new Map(payload.products.filter(product => Array.isArray(product.variants))
          .map(product => [product.handle, product]));
        handles.forEach(handle => settle(handle, byHandle.get(handle) || null));
      } catch (error) {
        // A failed lookup is unknown availability, never proof of local stock.
        handles.forEach(handle => settle(handle, null));
      } finally {
        clearTimeout(timeout);
        activeRequests--;
        flush();
      }
    }

    function flush() {
      while (activeRequests < 2 && queue.length) {
        const batch = [];
        let queryLength = 0;
        // Shopify allows at most 20 all_products handles per rendered request.
        while (queue.length && batch.length < 20) {
          const length = encodeURIComponent(queue[0]).length + 3;
          if (batch.length && queryLength + length > 3500) break;
          queryLength += length;
          batch.push(queue.shift());
        }
        activeRequests++;
        fetchBatch(batch);
      }
    }

    class BroxCardStock extends HTMLElement {
      static get observedAttributes() { return ['data-handle']; }

      attributeChangedCallback(name, previous, current) {
        if (!this.card || previous === current) return;
        this.generation++;
        this.stockData = null;
        this.selectedVariantId = null;
        this.hidden = false;
        delete this.dataset.ready;
        delete this.dataset.status;
        this.replaceChildren();
        if (this.nearViewport) this.load();
      }

      connectedCallback() {
        this.generation = (this.generation || 0) + 1;
        this.card = this.closest('product-card');
        this.selectedVariantId = this.card?.querySelector('.js-option:checked[data-variant-id]')?.dataset.variantId || null;
        this.handleChange = event => {
          if (!event.target.matches('.js-option[data-variant-id]')) return;
          this.selectedVariantId = event.target.dataset.variantId;
          if (this.stockData) this.render(this.stockData);
          else this.load();
        };
        this.card?.addEventListener('change', this.handleChange);
        cards.add(this);
        if (observer) observer.observe(this);
        else { this.nearViewport = true; this.load(); }
      }

      disconnectedCallback() {
        this.generation++;
        observer?.unobserve(this);
        this.card?.removeEventListener('change', this.handleChange);
        cards.delete(this);
      }

      async load() {
        const handle = this.dataset.handle || '';
        if (!/^[\p{L}\p{N}_-]{1,255}$/u.test(handle)) { this.render(null); return; }
        const generation = this.generation;
        const data = await requestStock(handle);
        // Sledge may replace a card while its request is still in flight.
        if (!this.isConnected || generation !== this.generation) return;
        this.stockData = data;
        this.render(data);
      }

      render(data) {
        const wantedId = this.selectedVariantId || data?.initialVariantId;
        const variant = data?.variants.find(item => String(item.id) === String(wantedId));
        this.hidden = variant?.requiresShipping === false;
        if (this.hidden) return;
        const type = cardStatus(variant ? rules.classify(data, variant) : 'check-availability');
        const label = config.labels[type] || config.labels['check-availability'];
        const statuses = new Set(data?.variants.map(item => item.requiresShipping === false ? 'digital' : cardStatus(rules.classify(data, item))));
        const varies = !!data && (statuses.size > 1 || data.variantCount > data.variants.length);
        const line = document.createElement('span');
        line.className = 'brox-card-stock__line';
        const dot = document.createElement('span');
        dot.className = 'brox-card-stock__dot';
        dot.setAttribute('aria-hidden', 'true');
        const text = document.createElement('span');
        text.className = 'brox-card-stock__label';
        text.textContent = label;
        line.append(dot, text);
        this.replaceChildren(line);
        if (varies) {
          const note = document.createElement('span');
          note.className = 'brox-card-stock__note';
          note.textContent = config.varies;
          this.append(note);
        }
        this.dataset.status = type;
        this.dataset.ready = '';
      }
    }

    customElements.define('brox-card-stock', BroxCardStock);
    // Refresh restored pages without persisting inventory in local storage.
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      cache.clear();
      cards.forEach(card => { if (card.nearViewport) card.load(); });
    });
  }

  if (window.BroxStockRules) registerCardStock();
  else document.addEventListener('brox:stock-rules:ready', registerCardStock, { once: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brox-stock-rules"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.BroxStockRules) return;

  function parseManufacturerRule(tag) {
    const match = String(tag || '').trim().match(/^manufacturer-stock:(\d+)-(\d+)$/i);
    if (!match) return null;
    const minDays = Number(match[1]);
    const maxDays = Number(match[2]);
    return maxDays < minDays ? null : { minDays, maxDays };
  }

  function classify(product, variant) {
    if (!variant) return null;
    const localStock = Number(variant.inventoryQuantity) || 0;
    const tracked = String(variant.inventoryManagement).toLowerCase() === 'shopify';
    const stopsAtZero = String(variant.inventoryPolicy).toLowerCase() === 'deny';

    // Preserve the product-page priority, including deny-at-zero and built-to-order.
    if (tracked && localStock <= 0 && stopsAtZero) return 'discontinued';
    if (tracked && localStock > 0) return 'local';
    if (product.builtToOrder === true) return 'built-to-order';
    if (Number(variant.marcorStock) > 0) return 'marcor';
    if (Number(variant.jrpStock) > 0) return 'jrp';
    if (Number(variant.turn14Stock) > 0) return 'turn14';
    if (parseManufacturerRule(product.manufacturerTag)) return 'manufacturer';
    const allDistributorsZero = [variant.jrpStock, variant.marcorStock, variant.turn14Stock]
      .some(value => value === 0 || value === '0');
    if (!product.manufacturerTag && allDistributorsZero) return 'out-of-stock';
    // An unknown supplier value must never be treated as confirmed zero stock.
    return 'check-availability';
  }

  window.BroxStockRules = Object.freeze({ classify, parseManufacturerRule });
  document.dispatchEvent(new CustomEvent('brox:stock-rules:ready'));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brox-vehicle-system"] && !Shopify.designMode) return;
  try {
    (() => {
  const boot = async () => {
    if (customElements.get('brox-vehicle-picker')) return;
    const source = document.getElementById('BroxVehicleConfig');
    if (!source) return;
    let config;
    try { config = JSON.parse(source.textContent); } catch (_) { return; }
    const text = config.text;
    // V46: the first 50 admin entries render on the server, without an extra request.
    // Larger directories follow Shopify pagination rather than silently truncating.
    let adminRows = config.adminRows || [];
    if (config.adminCount > 50) {
      try {
        const allRows = [];
        let next = config.adminUrl;
        const visited = new Set();
        while (next) {
          const url = new URL(next, location.origin);
          if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid vehicle pagination');
          visited.add(url.href);
          url.searchParams.set('view', 'brox-vehicles');
          const response = await fetch(url, { signal: AbortSignal.timeout(8000) });
          if (!response.ok) throw new Error('Vehicle request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const page = JSON.parse(html.getElementById('BroxVehiclePage').textContent);
          if (!Array.isArray(page.rows)) throw new Error('Invalid vehicles');
          allRows.push(...page.rows);
          next = page.next;
        }
        adminRows = allRows;
      } catch (_) {
        document.querySelectorAll('[data-bv-load-warning]').forEach(node => { node.hidden = false; });
      }
    }
    const directory = new Map();
    [...config.vehicles, ...adminRows].forEach(row => {
      if (!Array.isArray(row) || row.length !== 6 || !row.every(value => typeof value === 'string')) return;
      const match = row[5].match(/(?:^|\/)collections\/([a-z0-9-]+)$/);
      if (!match) return;
      const values = row.slice(0, 5);
      directory.set(JSON.stringify(values), { values, url: '/collections/' + match[1] });
    });
    const vehicles = [...directory.values()];
    const key = 'brox.vehicle.v1';
    const identify = values => directory.get(JSON.stringify(values));
    const label = vehicle => vehicle ? vehicle.values.filter(Boolean).join(' · ') : text.select_vehicle;
    let selected = null;
    const read = () => {
      try { return identify(JSON.parse(localStorage.getItem(key))?.values) || null; } catch (_) { return null; }
    };
    const fromPath = value => {
      try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin) return null;
        const match = url.pathname.match(/\/collections\/([a-z0-9-]+)(?:\/products\/[^/]+)?\/?$/);
        return match ? match[1] : null;
      } catch (_) { return null; }
    };
    const forHandle = handle => {
      const candidates = vehicles.filter(vehicle => vehicle.url === '/collections/' + handle);
      const saved = read();
      return candidates.find(vehicle => saved && JSON.stringify(vehicle.values) === JSON.stringify(saved.values)) || candidates[0] || null;
    };
    const arrival = forHandle(config.collectionHandle || fromPath(window.location.href)) ||
      (document.querySelector('brox-product-fitment') ? forHandle(fromPath(document.referrer)) : null);
    selected = arrival || read();
    if (arrival) {
      try { localStorage.setItem(key, JSON.stringify({ values: arrival.values })); } catch (_) {}
    }
    const changed = () => document.dispatchEvent(new CustomEvent('brox:vehicle-change', { detail: selected }));
    const save = vehicle => {
      selected = vehicle;
      try {
        if (vehicle) localStorage.setItem(key, JSON.stringify({ values: vehicle.values }));
        else localStorage.removeItem(key);
      } catch (_) {}
      changed();
    };
    const destination = vehicle => {
      if (!vehicle || !/^\/collections\/[a-z0-9-]+$/.test(vehicle.url)) return null;
      const root = config.root.replace(/\/$/, '');
      return root + vehicle.url;
    };
    const navigate = vehicle => {
      const url = destination(vehicle);
      if (url) location.assign(url);
    };
    class VehiclePicker extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.selects = [...this.querySelectorAll('select')];
        this.fields = [...this.querySelectorAll('.bv-field')];
        this.error = this.querySelector('[data-bv-error]');
        this.values = selected ? selected.values.slice() : Array(5).fill(null);
        this.addEventListener('change', event => {
          const index = this.selects.indexOf(event.target);
          if (index < 0) return;
          this.values[index] = event.target.value ? JSON.parse(event.target.value) : null;
          this.values.fill(null, index + 1);
          this.error.hidden = true;
          this.fill();
          if (this.complete()) this.commit();
        }, options);
        this.querySelector('form').addEventListener('submit', event => {
          event.preventDefault();
          const vehicle = this.complete();
          if (!vehicle) {
            this.error.hidden = false;
            this.selects.find((select, i) => !this.fields[i].hidden && this.values[i] === null)?.focus();
            return;
          }
          this.commit();
        }, options);
        this.querySelector('[data-bv-clear]').addEventListener('click', () => {
          this.values = Array(5).fill(null);
          this.error.hidden = true;
          this.fill();
          this.selects[0].focus();
        }, options);
        document.addEventListener('brox:vehicle-change', () => this.sync(), options);
        this.fill();
        if (this.staysOnProduct()) this.querySelector('[type="submit"]').textContent = text.use_vehicle;
        this.querySelectorAll('button').forEach(button => { button.disabled = false; });
      }
      staysOnProduct() {
        return !!this.closest('#BroxGarageDialog') && !!document.querySelector('brox-product-fitment');
      }
      commit() {
        const vehicle = this.complete();
        if (!vehicle) return;
        save(vehicle);
        if (this.staysOnProduct()) this.closest('dialog').close();
        else navigate(vehicle);
      }
      disconnectedCallback() { this.abort?.abort(); this.abort = null; }
      sync() {
        this.values = selected ? selected.values.slice() : Array(5).fill(null);
        this.fill();
      }
      complete() { return this.values.every(value => value !== null) ? identify(this.values) : null; }
      fill() {
        for (let i = 0; i < 5; i++) {
          const ready = this.values.slice(0, i).every(value => value !== null);
          const candidates = ready ? vehicles.filter(vehicle => vehicle.values.slice(0, i).every((v, j) => v === this.values[j])) : [];
          const choices = [...new Set(candidates.map(vehicle => vehicle.values[i]))].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
          const select = this.selects[i];
          select.replaceChildren(new Option(select.dataset.placeholder, ''));
          this.fields[i].hidden = ready && choices.length === 1 && choices[0] === '';
          if (this.fields[i].hidden) this.values[i] = '';
          else if (!choices.includes(this.values[i])) this.values[i] = null;
          choices.forEach(value => select.add(new Option(value || text.not_specified, JSON.stringify(value))));
          select.value = this.values[i] === null ? '' : JSON.stringify(this.values[i]);
          select.disabled = !ready || this.fields[i].hidden;
          select.required = ready && !this.fields[i].hidden;
        }
      }
    }
    customElements.define('brox-vehicle-picker', VehiclePicker);
    const dialog = document.getElementById('BroxGarageDialog');
    const savedPanel = dialog.querySelector('[data-bv-saved]');
    const pickerPanel = dialog.querySelector('[data-bv-picker-panel]');
    let opener = null;
    let bodyOverflow = '';
    const open = (trigger, edit = false) => {
      opener = trigger;
      savedPanel.hidden = edit || !selected;
      pickerPanel.hidden = !savedPanel.hidden;
      dialog.querySelector('[data-bv-dialog-title]').textContent = pickerPanel.hidden ? text.my_garage : text.choose_vehicle;
      dialog.querySelector('brox-vehicle-picker')?.sync();
      if (!dialog.open) {
        bodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
      }
      if (!pickerPanel.hidden) dialog.querySelector('select:not([disabled])')?.focus();
    };
    dialog.addEventListener('close', () => {
      document.body.style.overflow = bodyOverflow;
      if (opener?.isConnected) opener.focus();
    });
    dialog.querySelector('[data-bv-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.querySelector('[data-bv-edit]').addEventListener('click', () => open(opener, true));
    dialog.querySelector('[data-bv-remove]').addEventListener('click', () => { save(null); open(opener, true); });
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-bv-open]');
      if (trigger) { event.preventDefault(); open(trigger, trigger.dataset.bvOpen === 'edit'); }
    });
    const updateGarage = () => {
      document.querySelectorAll('[data-bv-garage-label]').forEach(node => { node.textContent = selected ? selected.values.filter(Boolean).join(' ') : text.select_vehicle; });
      document.querySelectorAll('[data-bv-open="garage"]').forEach(node => { node.hidden = false; node.title = label(selected); });
      dialog.querySelector('[data-bv-saved-label]').textContent = label(selected);
      const link = dialog.querySelector('[data-bv-shop]');
      link.href = destination(selected) || config.root + 'collections';
    };
    document.addEventListener('brox:vehicle-change', updateGarage);
    document.addEventListener('shopify:section:load', updateGarage);
    window.addEventListener('storage', event => { if (event.key === key || event.key === null) { selected = read(); changed(); } });
    window.addEventListener('pageshow', event => { if (event.persisted) { selected = read(); changed(); } });
    class ProductFitment extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        try { this.product = JSON.parse(this.querySelector('[data-bv-product]').textContent); } catch (_) { return; }
        this.variant = this.product.variant;
        const options = { signal: this.abort.signal };
        this.status = this.querySelector('[data-bv-status]');
        this.vehicleLabel = this.querySelector('[data-bv-vehicle]');
        this.contact = this.querySelector('[data-bv-contact]');
        this.link = this.querySelector('[data-bv-email]');
        this.changeButton = this.querySelector('[data-bv-open]');
        this.changeButton.disabled = false;
        const tableLink = this.querySelector('[data-bv-check-table]');
        if (tableLink) {
          const target = document.getElementById(tableLink.hash.slice(1));
          tableLink.hidden = !target;
          tableLink.addEventListener('click', event => {
            if (!target) return;
            event.preventDefault();
            target.classList.remove('is-closing');
            target.open = true;
            target.querySelector('.disclosure__panel')?.removeAttribute('style');
            requestAnimationFrame(() => {
              target.querySelector('.disclosure__panel')?.removeAttribute('style');
              target.querySelector('summary')?.focus({ preventScroll: true });
              target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
            });
          }, options);
        }
        this.update();
        document.addEventListener('brox:vehicle-change', () => this.update(), options);
        this.closest('.js-product')?.addEventListener('on:variant:change', event => {
          this.variant = event.detail.variant || null;
          this.updateEmail();
        }, options);
      }
      disconnectedCallback() { this.abort?.abort(); this.abort = null; }
      update() {
        const handle = selected?.url.split('/').pop();
        const matches = !!handle && Array.isArray(this.product.collections) && this.product.collections.includes(handle);
        this.dataset.state = selected ? (matches ? 'match' : 'confirmation') : 'empty';
        this.status.textContent = selected ? (matches ? text.fits : text.needs_confirmation) : text.verify_fitment;
        this.vehicleLabel.textContent = selected ? label(selected) : text.select_to_check;
        this.contact.hidden = !selected || matches;
        this.querySelector('[data-bv-check-icon]').toggleAttribute('hidden', !matches);
        this.querySelector('[data-bv-question-icon]').toggleAttribute('hidden', matches);
        this.changeButton.textContent = selected ? text.not_your_vehicle : text.select_vehicle;
        this.updateEmail();
      }
      updateEmail() {
        if (!selected) { this.link.removeAttribute('href'); return; }
        const variant = this.variant;
        const productUrl = new URL(this.product.url, this.product.shopUrl);
        if (variant?.id) productUrl.searchParams.set('variant', variant.id);
        const subject = text.email_subject + ' — ' + (variant?.sku || this.product.title);
        const body = [text.email_request, '', text.vehicle + ': ' + label(selected), text.product + ': ' + this.product.title,
          text.variant + ': ' + (variant?.title || text.not_selected), text.part_number + ': ' + (variant?.sku || text.not_specified),
          text.product_link + ': ' + productUrl.href].join('\n');
        this.link.href = 'mailto:sales@broxtuning.ca?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      }
    }
    customElements.define('brox-product-fitment', ProductFitment);
    class FitmentTable extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const message = this.querySelector('[data-bv-table-message]');
        let handles;
        try { handles = new Set(JSON.parse(this.querySelector('[data-bv-table-collections]').textContent)); }
        catch (_) { message.textContent = text.fitment_empty; return; }
        const seen = new Set();
        const rows = vehicles.filter(vehicle => {
          const identity = JSON.stringify(vehicle.values);
          if (!handles.has(vehicle.url.split('/').pop()) || seen.has(identity)) return false;
          seen.add(identity);
          return true;
        }).sort((a, b) => a.values.join(' ').localeCompare(b.values.join(' '), undefined, { numeric: true }));
        if (!rows.length) { message.textContent = text.fitment_empty; return; }
        const fragment = document.createDocumentFragment();
        rows.forEach(vehicle => {
          const row = document.createElement('tr');
          vehicle.values.forEach(value => {
            const cell = document.createElement('td');
            cell.textContent = value || '—';
            row.appendChild(cell);
          });
          fragment.appendChild(row);
        });
        this.querySelector('tbody').replaceChildren(fragment);
        message.hidden = true;
        this.querySelector('[data-bv-table-wrap]').hidden = false;
        this.querySelector('[data-bv-table-hint]').hidden = false;
      }
    }
    customElements.define('brox-fitment-table', FitmentTable);

    updateGarage();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
  } catch(e) { console.error(e); }
})();

})();
